import React, { useState } from "react";

import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Offcanvas } from "react-bootstrap";

import "./DefaultLayout.css";
import { Link } from "react-router-dom";

import AppSidebar from "./app_sidebar/AppSidebar";
import AppHeader from "./app_header/AppHeader";
import AppContent from "./app_content/AppContent";


const DefaultLayout = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  console.log("setShow", show);

  return (
    <>
      <div className="DefaultLayout">
        <div className="row me-0 ms-0">
          <div className="col-xl-2 col-lg-3  me-0 ms-0 p-0">
            <div className="sidebar-div">
              <div className="destopviewsidebar">
                <AppSidebar />
              </div>
            </div>
          </div>
          <div className="col-xl-10 col-lg-9 me-0 ms-0 p-0">
            <div className="header_holder">
              <AppHeader />

              <div className="mobileviewsidebar">
                <button className="sidebaropnbtn" onClick={handleShow}>
                  <FontAwesomeIcon icon={faRightLeft} />
                </button>
                <Offcanvas
                  className="mobile_offcanvas"
                  show={show}
                  onHide={handleClose}
                  scroll={false} // ✅ avoids trying to remove scroll listeners
                  backdrop={true}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                      <div className="logo_div">
                        <Link to="/">
                          {/* <img src={logo} alt="logo" className="logo_img" /> */}
                        </Link>
                      </div>
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <AppSidebar
                      closeSidebar={() => {
                        setShow(false);
                      }}
                    />
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            </div>

            <div className="content-div">
              <AppContent />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DefaultLayout;
